<template>
    <div class="video-settings-panel" :class="{ opened: isExtended }" @click.stop.prevent="">
        <video-settings />

        <div class="toggle-handle" @click.stop.prevent="toggleVideoSettings">
            <i class="fa fa-chevron-left" />
        </div>
    </div>
</template>

<script>
import VideoSettings from './VideoSettings'

export default {
    name: 'VideoSettingsPanel',
    components: {
        VideoSettings
    },
    data: () => ({
        isExtended: false
    }),
    methods: {
        toggleVideoSettings() {
            this.isExtended = !this.isExtended
        }
    }
}
</script>

<style lang="scss" scoped>
.video-settings-panel {
    .video-settings {
        height: 100%;
        z-index: 21;
        width: 0;
        overflow-x: hidden;
        transition: all 0.2s linear;
    }

    .toggle-handle {
        position: absolute;
        top: calc(50% - 23px);
        left: -30px;
        width: 30px;
        height: 46px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: $blue;
        z-index: 22;
        transition: all 0.2s linear;

        .fa-chevron-left {
            color: $dark-5;
            font-size: 13pt;
            // makes icon thinner
            -webkit-text-stroke: 0.05rem $blue;
        }
    }

    &.opened {
        .video-settings {
            width: 220px;
        }

        .toggle-handle {
            left: -15px;

            .fa-chevron-left {
                transform: rotate(180deg);
            }
        }
    }
}
</style>
